import React, { useRef, useState } from 'react';
import html2pdf from 'html2pdf.js';
import { savePDFForm } from './supabaseService';

const CHECKLIST_ITEMS = [
  'Mens toilet',
  'Womens toilet',
  'Customers toilet',
  'Garage office',
  'Showroom offices',
  'Desks',
  'Chairs',
  'Glass doors',
  'Bins emptied',
  'Showroom floors',
  'Vaccuming',
  'Coffe machine',
  'Reception area floors',
  'Reception desks',
];

const styles = {
  container: {
    maxWidth: 700,
    margin: '40px auto',
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
    padding: 24,
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    textAlign: 'center',
    fontSize: 28,
    fontWeight: 800,
    color: '#0a3d91',
    marginBottom: 8,
    letterSpacing: 1,
  },
  subtitle: {
    textAlign: 'center',
    fontSize: 16,
    color: '#222',
    marginBottom: 18,
    fontWeight: 500,
  },
  checklistItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 0',
    borderBottom: '1px solid #eee',
    fontSize: 16,
  },
  label: {
    fontWeight: 600,
    fontSize: 15,
    color: '#0a3d91',
    marginBottom: 2,
  },
  radioGroup: {
    display: 'flex',
    gap: 16,
    alignItems: 'center',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: 15,
    border: '1.5px solid #0a3d91',
    borderRadius: 8,
    background: '#fff',
    color: '#222',
    marginBottom: 0,
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    minHeight: 60,
    padding: '10px 12px',
    fontSize: 15,
    border: '1.5px solid #0a3d91',
    borderRadius: 8,
    background: '#fff',
    color: '#222',
    resize: 'vertical',
    marginBottom: 0,
  },
  button: {
    display: 'block',
    margin: '32px auto 0',
    padding: '12px 36px',
    fontSize: 18,
    fontWeight: 600,
    color: '#fff',
    background: 'linear-gradient(90deg, #0a3d91 0%, #222 100%)',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(10,61,145,0.08)',
    transition: 'background 0.2s',
  },
  logo: {
    width: 90,
    height: 'auto',
    display: 'block',
    margin: '24px auto 0',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
};

export default function VWCorkillChecklist() {
  const [date, setDate] = useState('');
  const [staffName, setStaffName] = useState('');
  const [checklist, setChecklist] = useState(CHECKLIST_ITEMS.map(() => ''));
  const [comments, setComments] = useState('');
  const pdfRef = useRef();

  const handleChecklistChange = (idx, value) => {
    setChecklist(list => list.map((v, i) => i === idx ? value : v));
  };

  const generatePDF = async () => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      
      const pdfHtml = `
        <div style="font-family: 'Segoe UI', Arial, sans-serif; background: #fff; padding: 0; margin: 0;">
          <div style="background: linear-gradient(90deg, #0a3d91 0%, #222 100%); padding: 18px 0 12px 0; text-align: center; border-radius: 0 0 18px 18px; box-shadow: 0 2px 12px rgba(10,61,145,0.10);">
            <div style='font-size: 30px; font-weight: 900; color: #fff; letter-spacing: 1.2px; margin-bottom: 2px;'>VW Corkill Checklist</div>
            <div style='font-size: 18px; color: #fff; font-weight: 500; margin-top: 8px;'>Date: ${date || currentDate} &nbsp; | &nbsp; Staff: ${staffName || '<span style="color:#eee">(Not specified)</span>'}</div>
          </div>
          <div style="padding: 24px;">
            <div style='margin-bottom: 32px; background: #fafbfc; border-radius: 12px; padding: 20px; border: 1.5px solid #eee;'>
              <div style='font-size: 20px; font-weight: 700; color: #0a3d91; margin-bottom: 16px; border-bottom: 2px solid #0a3d91; padding-bottom: 8px;'>Cleaning Tasks</div>
          <table style='width: 100%; border-collapse: collapse; font-size: 16px; margin-top: 4px;'>
            <thead>
              <tr style='background: #0a3d91;'>
                    <th style='padding: 10px 8px; color: #fff; font-size: 15px; font-weight: 700; border-bottom: 2px solid #222;'>Task</th>
                    <th style='padding: 10px 8px; color: #fff; font-size: 15px; font-weight: 700; border-bottom: 2px solid #222;'>Status</th>
              </tr>
            </thead>
            <tbody>
              ${CHECKLIST_ITEMS.map((item, i) => `
                    <tr style='background: ${i%2===0 ? '#fff' : '#f6f6f6'};'>
                      <td style='padding: 10px 8px; color: #222; border-bottom: 1px solid #eee; font-weight: 500;'>${item}</td>
                      <td style='text-align: center; padding: 10px 8px; border-bottom: 1px solid #eee; font-size: 16px; font-weight: 600; color: ${checklist[i] ? '#0a3d91' : '#111'};'>${checklist[i] || '<span style="color:#bbb;">(Not completed)</span>'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
              <div style='margin-top: 24px;'>
                <div style='font-size: 15px; font-weight: 600; color: #0a3d91; margin-bottom: 6px;'>Comments:</div>
                <div style='min-height: 48px; border: 1.5px solid #0a3d91; border-radius: 8px; background: #fafbfc; padding: 10px 12px; font-size: 15px; color: #222;'>${comments || '<span style="color:#bbb;">(No comments)</span>'}</div>
              </div>
        </div>
            <img src='/vwlogo.png' alt='VW Logo' style='width: 90px; height: auto; border-radius: 12px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); display:block; margin: 32px auto 0 auto;' />
        </div>
      </div>
    `;

      // Generate PDF as blob
      const pdfBlob = await html2pdf()
      .set({
        margin: 0,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
        .from(pdfHtml)
        .outputPdf('blob');

             // Create filename with form name + date
       const fileName = `VW_Corkill_Checklist_${currentDate}.pdf`;

       // Save to Supabase
       const formData = {
         formType: 'vwcorkill',
         title: 'VW Corkill Checklist',
         location: 'Not specified',
         createdBy: staffName || 'Not specified',
         date: date || currentDate,
         staffName: staffName || 'Not specified',
         formData: { checklist: checklist },
         comments: { general: comments }
       };

                   await savePDFForm(formData, pdfBlob, fileName);
      
      // Also download locally for user convenience
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert('PDF saved to library and downloaded successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    }
  };

  const mobileStyle = `
    @media (max-width: 600px) {
      .vwcorkill-container { padding: 0 !important; border-radius: 0 !important; box-shadow: none !important; background: #f6f7fb !important; }
      .vwcorkill-title { font-size: 1.3rem !important; }
      .vwcorkill-checklistItem { padding: 10px 4px !important; border-radius: 8px !important; }
      .vwcorkill-label { font-size: 13px !important; }
      .vwcorkill-input, .vwcorkill-textarea { font-size: 15px !important; padding: 8px !important; border-radius: 8px !important; width: 100% !important; min-width: 0 !important; max-width: 100vw !important; }
      .vwcorkill-button { font-size: 16px !important; padding: 12px 0 !important; border-radius: 10px !important; max-width: 100vw !important; }
    }
  `;

  return (
    <div style={styles.container} className="vwcorkill-container">
      <style>{mobileStyle}</style>
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 32, marginBottom: 18}}>
        <img src="/vwlogo.png" alt="VW Logo" style={{width: 70, height: 'auto', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)'}} />
        <img src="/logo.jpg" alt="Married to the Mop Logo" style={{width: 90, height: 'auto', borderRadius: 12, boxShadow: '0 1px 4px rgba(176,0,0,0.08)'}} />
      </div>
      <div style={styles.title} className="vwcorkill-title">VW Corkills Cleaning Checklist</div>
      <div style={styles.subtitle}>Please complete the checklist below. All items require a Yes/No answer. Add comments at the end if needed.</div>
      <div style={{ marginBottom: 18 }}>
        <div style={styles.label}>Date:</div>
        <input
          style={styles.input}
          className="vwcorkill-input"
          type="date"
          value={date}
          onChange={e => setDate(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 18 }}>
        <div style={styles.label}>Staff Name:</div>
        <input
          style={styles.input}
          className="vwcorkill-input"
          type="text"
          value={staffName}
          onChange={e => setStaffName(e.target.value)}
          placeholder="Enter your name..."
        />
      </div>
      {CHECKLIST_ITEMS.map((item, idx) => (
        <div key={idx} style={styles.checklistItem} className="vwcorkill-checklistItem">
          <span>{item}</span>
          <div style={styles.radioGroup}>
            <label>
              <input
                type="radio"
                name={`checklist-${idx}`}
                value="yes"
                checked={checklist[idx] === 'yes'}
                onChange={() => handleChecklistChange(idx, 'yes')}
              />{' '}Yes
            </label>
            <label>
              <input
                type="radio"
                name={`checklist-${idx}`}
                value="no"
                checked={checklist[idx] === 'no'}
                onChange={() => handleChecklistChange(idx, 'no')}
              />{' '}No
            </label>
          </div>
        </div>
      ))}
      <div style={{ margin: '24px 0 0 0' }}>
        <div style={styles.label}>Comments:</div>
        <textarea
          style={styles.textarea}
          className="vwcorkill-textarea"
          value={comments}
          onChange={e => setComments(e.target.value)}
          placeholder="Add any comments here..."
        />
      </div>
      <button style={styles.button} className="vwcorkill-button" onClick={generatePDF}>Download PDF</button>
      <img src="/vwlogo.png" alt="VW Logo" style={styles.logo} />
    </div>
  );
}
